<template>
  <div class="blocking-website-component">
    <h1 class="title">Targeting</h1>
    <div class="targeting-description">
      Access all your previously saved targeted audiences. Fully manage all your targeted websites.
    </div>

    <vx-card class="targeting-container mt-10" :noShadow="true">
      <vue-tabs ref="tabsContainer" v-model="activeTab">

        <v-tab key="audiences" tabKey="audiences">
          <div slot="title" @click="$gtag.event('Audience_tab')" v-on:click="goTo('audiences')">
            <h4 class="targeting-tabs-title align-middle py-3 px-5">
              <vs-icon class="speakol-tabs-icons" icon="speakol-audience" icon-pack="speakol"></vs-icon>
              {{ $t("Audiences") }}
            </h4>
          </div>
        </v-tab>

        <v-tab key="publishers" tabKey="publishers">
          <div slot="title" @click="$gtag.event('Publishers_tab')" v-on:click="goTo('publishers')">
            <h4 class="targeting-tabs-title align-middle py-3 px-5">
              <vs-icon class="speakol-tabs-icons" icon="speakol-www" icon-pack="speakol"></vs-icon>
              {{ $t("Publishers") }}
            </h4>
          </div>
        </v-tab>


        <router-view></router-view>
      </vue-tabs>
    </vx-card>
  </div>
</template>


<script>
import '@/components/vue-nav-tabs/nav-tabs.scss'
import { VueTabs, VTab } from '@/components/vue-nav-tabs/vue-nav-tabs.js'

export default {
  data () {
    return {
      activeTab: null
    }
  },
  components: {
    VueTabs,
    VTab
  },
  created () {
    this.activeTab = this.getActiveTabByCurrentRouteName()
  },
  methods: {
    getActiveTabByCurrentRouteName () {
      if (this.$route.name === 'publishers-view') {
        return 'publishers'
      }
      return 'audiences'
    },
    goTo (param) {
      if (this.$route.name === `${param}.view`) return
      this.$router.push(`/targeting/${param}`)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ag-cell-wrapper {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.blocking-website-component {
  /deep/ .tabs__link {
    padding-bottom: 0 !important;
  }

  .nav-tabs {
    padding-left: 28px;
  }
}

.important-note-desc {
  color: #999;
}

.title {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  color: #2c2c2c;
}

.targeting-description {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #999;
  margin-top: 5px;
}

.targeting-container /deep/ .vx-card__body {
  padding: 0 !important;
}

.tab.active h4 {
  color: #0092d7;
}

.speakol-tabs-icons {
  position: relative;
  top: 3px;
  right: 7px;
}

.targeting-tabs-title {
  font-size: 18px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .tabs__link {
    width: max-content;
  }

  .nav-tabs {
    display: flex;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    width: max-content;
  }
}

@media (max-width: 576px) {
  .blocking-website-component {
    .title {
      font-size: 18px;
    }

    .targeting-description {
      font-size: 14px;
    }

    .targeting-tabs-title {
      font-size: 14px;
    }

    .speakol-tabs-icons {
      font-size: 18px !important;
    }
  }
}
</style>

